import { render } from "./ContentParticipations.vue?vue&type=template&id=51e09506"
import script from "./ContentParticipations.vue?vue&type=script&lang=js"
export * from "./ContentParticipations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__